module.exports = __webpack_public_path__ + "static/Foto_originale-683bc6a068dbadc0f0afffd90414f85e.jpg";